import {
    Timeline as V4Timelilne,
    TimelineProps as V4TimelineProps,
} from "antd";

import { TimelineItem } from "./Timeline.types";

// antd >5.2 exposes a timeline prop and type for this, so Timeline.Item is no longer necessary
// This will be the only supported usage in >6
// https://ant.design/components/timeline
// If we're on antd >5.2, replace this interface, remove Timeline comp

interface TimelineProps extends V4TimelineProps {
    items: TimelineItem[];
}
// Avoid changing - this is meant to be compatible with API in antd 5
export const Timeline = ({
    items,
    className,
    mode,
    pending,
    pendingDot,
    prefixCls,
    reverse,
    style,
}: TimelineProps) => {
    return (
        <V4Timelilne
            className={className}
            mode={mode}
            pending={pending}
            pendingDot={pendingDot}
            prefixCls={prefixCls}
            reverse={reverse}
            style={style}
        >
            {items.map((item, i) => (
                <V4Timelilne.Item
                    key={i}
                    position={item.position}
                    color={item.color}
                    dot={item.dot}
                    label={item.label}
                >
                    {item.children}
                </V4Timelilne.Item>
            ))}
        </V4Timelilne>
    );
};
